export const HERO_CONSTANTS = {
  TAG: "Tech Innovation",
  DATE: "October 23, 2023",
  TITLE: "The Future of Transparency with Digital Product Passports",
  DESCRIPTION:
    "Explore how digital product passports are revolutionizing supply chain transparency and consumer trust by providing detailed product information.",
  HERO_IMAGE:
    "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
};

export const ARTICLE_SUMMARY = [
  "Digital product passports are transforming the way consumers and businesses interact with products by providing comprehensive information about their origin, composition, and lifecycle. This guide explores the benefits and applications of digital product passports in enhancing transparency and trust.",
  "From improving supply chain visibility to empowering consumers with detailed product data, digital product passports offer numerous advantages. We'll delve into the technology behind these passports and how they are reshaping various industries.",
  "Whether you're a business looking to enhance transparency or a consumer seeking more information about the products you buy, digital product passports provide valuable insights. Let's explore the future of transparency with digital product passports.",
];

export const ARTICLE_STEPS = [
  {
    title: "1. Understanding Digital Product Passports",
    content:
      "Digital product passports are digital records that contain detailed information about a product's origin, composition, and lifecycle. These passports leverage blockchain technology to ensure data integrity and transparency, providing consumers and businesses with reliable product information.",
  },
  {
    title: "2. Key Features and Benefits",
    content:
      "Digital product passports offer several key features, including traceability, authenticity verification, and sustainability information. These features help businesses improve supply chain transparency and build consumer trust by providing accurate and comprehensive product data.",
  },
  {
    title: "3. Applications in Different Industries",
    content:
      "Digital product passports are used across various industries, including fashion, electronics, and food. In fashion, they provide information about the materials and manufacturing processes used. In electronics, they offer details about component sourcing and recycling options. In the food industry, they ensure traceability from farm to table.",
  },
  {
    title: "4. Enhancing Consumer Trust",
    content:
      "By providing detailed product information, digital product passports empower consumers to make informed purchasing decisions. This transparency helps build trust and loyalty, as consumers can verify the authenticity and sustainability of the products they buy.",
  },
  {
    title: "5. Future Trends and Developments",
    content:
      "The field of digital product passports is constantly evolving, with new advancements and features being introduced regularly. Staying informed about the latest trends and developments helps businesses leverage the full potential of these passports and stay ahead of the competition.",
  },
  {
    title: "6. Implementing Digital Product Passports",
    content:
      "When implementing digital product passports, businesses should consider factors such as data integration, scalability, and user experience. Partnering with technology providers that offer robust support and integration options can help ensure a successful implementation.",
  },
];

export const RELATED_ARTICLES = [
  {
    image:
      "https://images.pexels.com/photos/3184466/pexels-photo-3184466.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 20, 2023",
    title: "Top Innovations in Supply Chain Transparency",
    description:
      "Explore the latest innovations in supply chain transparency, from digital product passports to blockchain technology. Learn how these advancements are improving visibility and trust.",
  },
  {
    image:
      "https://images.pexels.com/photos/3184467/pexels-photo-3184467.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 15, 2023",
    title: "How Technology is Enhancing Consumer Trust",
    description:
      "Discover the various ways technology is enhancing consumer trust, from digital product passports to secure payment systems. Understand the impact of these technologies on consumer behavior.",
  },
  {
    image:
      "https://images.pexels.com/photos/3184468/pexels-photo-3184468.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 12, 2023",
    title: "Implementing Blockchain for Product Transparency",
    description:
      "Learn how to implement blockchain technology for product transparency. Follow our guide to understand the benefits and challenges of using blockchain in your supply chain.",
  },
];

export const FOOTER_CONSTANTS = {
  CTA_TITLE: "Embrace Transparency with Digital Product Passports",
  CTA_BACKGROUND:
    "https://images.pexels.com/photos/3184469/pexels-photo-3184469.jpeg",
  EMAIL_PLACEHOLDER: "Enter your email address",
  BUTTON_TEXT: "Learn More",
  COPYRIGHT: " 2024 Transparency Tech. All rights reserved",
};
